/** @format */

import React from "react";

const ApprovalBar = ({ approvers, requestCurrentStatus }) => {
  return (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      {approvers.map((approver, index) => (
        <div
          key={index}
          style={{
            flex: 1,
            margin: "0",
            padding: "10px",
            backgroundColor:
              requestCurrentStatus &&
              requestCurrentStatus.some(
                (status) => status.app_title === approver
              )
                ? "green"
                : requestCurrentStatus &&
                  requestCurrentStatus.some(
                    (status) => status.declined_by === approver
                  )
                ? "red"
                : "grey",
            color: "white",
            textAlign: "center",
            fontSize: "10px",
          }}
        >
          {approver}
        </div>
      ))}
    </div>
  );
};

export default ApprovalBar;
